import dynamic from 'next/dynamic'
import { Header } from '@fe-toolkit/web-components/ssr'
import { accountLinks, headerLinks } from '@fe-toolkit/utility'

import { AUTH_URL, URL } from '@/constants'

// A separate chunk, so pages with the Brand Refresh flag off don't download
// feds-ui and Tamagui.
const BrandRefreshHeader = dynamic(() => import('./BrandRefreshHeader'))

// Shared by next/dynamic `loading`, the FederatedComponentBoundary fallback and
// the errorLoadRemote registry (mfOfflineHandlingPlugin.js), so the degraded UI
// is identical whichever failure mode fires.
export default function FallbackHeader({
  username,
  isBrandRefresh = false,
  isBlackFriday = false,
  isBlackFridayPrereg = false,
}: {
  username?: string
  isBrandRefresh?: boolean
  isBlackFriday?: boolean
  isBlackFridayPrereg?: boolean
}) {
  if (isBrandRefresh) {
    return (
      <BrandRefreshHeader
        isBlackFriday={isBlackFriday}
        isBlackFridayPrereg={isBlackFridayPrereg}
        username={username}
      />
    )
  }

  return (
    <Header
      accountImageUrl={URL.DEFAULT_AVATAR}
      accountLinks={accountLinks}
      authUrlDashboard={AUTH_URL.DASHBOARD}
      authUrlLogIn={AUTH_URL.LOG_IN}
      authUrlLogOut={AUTH_URL.LOG_OUT}
      links={headerLinks}
      username={username}
    />
  )
}
